<template>
  <footer className="m-footer" :style="cssVars">
    <div className="go-to-main-site">
      <a href="/" @click="$emit('go-to-main-click')">
        <span className="icon-ms_leaf"></span>Go to Main Site
      </a>
    </div>
    <div className="follow-us">
      <ul>
        <li>
          <a href="https://www.facebook.com/maplestory" target="_blank" @click="$emit('link-click', 'facebook')">
            <i className="icon fab fa-facebook-square"></i>
          </a> 
        </li>
        <li>
          <a href="https://twitter.com/maplestory" target="_blank" @click="$emit('link-click', 'twitter')">
            <i className="icon fab fa-twitter"></i>
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/user/maplestory" target="_blank" @click="$emit('link-click', 'youtube')">
            <i className="icon fab fa-youtube"></i>
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/maplestory/" target="_blank" @click="$emit('link-click', 'instagram')">
            <i className="icon fab fa-instagram"></i>
          </a>
        </li>
        <li>
          <a href="https://www.twitch.tv/maplestory" target="_blank" @click="$emit('link-click', 'twitch')">
            <i className="icon fab fa-twitch"></i>
          </a>
        </li>
        <li>
          <a href="https://discord.gg/maplestory" target="_blank" @click="$emit('link-click', 'discord')">
            <i className="icon fab fa-discord"></i>
          </a>
        </li>
        <li>
          <a href="https://www.tiktok.com/@maplestory" target="_blank" @click="$emit('link-click', 'tiktok')">
            <i className="icon fab fa-tiktok"></i>
          </a>
        </li>
      </ul>
    </div>

    <div className="copy-links">
      <div className="copyright">
        © {{new Date().getFullYear()}} NEXON Korea Corporation & NEXON America Inc. All Rights Reserved. 
      </div>

      <div className="account-links">
        <a href="//www.nexon.com/main/en/legal/privacy" target="_blank" className="privacy" @click="$emit('link-click', 'Privacy Policy')">
          Privacy Policy
        </a>
        <a href="//www.nexon.com/main/en/legal/tou/" target="_blank" className="termsofuse" @click="$emit('link-click', 'Terms of Use')">
          Terms of Use
        </a>
        <a target="_blank" :href="`https://${nexonNetEnv}www.nexon.net/cookiepolicy`" @click="$emit('link-click', 'Cookie Policy')">Cookie Policy</a>
        <a target="_blank" className="ot-sdk-show-settings" @click="$emit('link-click', 'Cookie Settings')">Cookie Settings</a>
      </div>
    </div>

  </footer>
</template>

<script>
import OneTrust from '@/services/browser/OneTrust'
import '@/assets/fonts/microsites/common/icons.scss'

export default {
  name: 'MicrositeFooter',
  props: {
    color: {
      type: String,
      default: "red"
    },
    hoverColor: {
      type: String,
      default: "blue"
    },
    backgroundColor: {
      type: String,
      default: "black"
    }
  },
  data () {
    return {
      nexonNetEnv: process.env.VUE_APP_NEXON_NET_ENV_PREFIX,
    }
  },
  mounted(){
    OneTrust();
  },

  methods: {
    cookieSettingMenu(){
      setTimeout( ()=>{
        const $cookieSettingMenu = document.querySelector(".ot-sdk-show-settings");
        if( $cookieSettingMenu.firstChild.nodeValue.includes("Cookie Settings") ){
          $cookieSettingMenu.style.display = "none";
        }
      },100)
    }
  }
}
</script>

<style scoped lang="scss">

$footerRest: v-bind(color);
$footerHover: v-bind(hoverColor);
$backgroundColor: v-bind(backgroundColor);
.m-footer {
  color: v-bind(color);
  padding: 1rem 0 1rem; //background: white;
  text-align: center;
  background: $backgroundColor;
  .copyright-game { 
    position: relative;
    font-size: 0.6rem;
    color: $footerHover;
    margin-bottom: 0.6rem;
  }
  .go-to-main-site {
    display: inline-block;
    font-size: 0.8rem;
    text-transform: uppercase;
    a {
      color: v-bind(color);
      text-decoration: none;
      transition: .2s ease-in-out;
      position: relative;
      .icon-ms_leaf{
        display: inline-block;
        margin-right: 0.4rem;
        vertical-align: sub;
        &:before {
          transition: .3s ease-in-out;
          font-size: 1.1rem;
          color: v-bind(color);
        }
      }
    }
    &:hover {
      a{
        color: v-bind(hoverColor);
        .icon-ms_leaf {
          &:before {
            color: v-bind(hoverColor);
          }
        }
      }
    }
  }
  .copy-links {
    display: flex;
    justify-content: center;
    a{ cursor: pointer; text-decoration: underline;}
  }
  .follow-us {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    font-size: 0.6rem;
    vertical-align: middle;
    padding-top: .4rem;
    padding-bottom: .4rem;
    ul {
      margin-bottom: 0;
      padding-left: 0;
    }
    li {
      display: inline-block;
      margin-right: 1.5rem;
      vertical-align: middle;
      &:last-child {
        margin-right: 0;
      }
    }
    .icon {
      color: v-bind(color);
      font-size: 1.4rem;
      line-height: 1.2rem;
      transition: color .2s ease-in-out;
      &:hover{
        color: $footerHover;
      }
    }
  }
  .locales {
    display: flex;
    justify-content: center;
    margin-bottom: 0.75rem;
  }
  .social-links {
    display: flex;
    justify-content: center;
    .nav-item { 
      padding: 0 0.2rem;
    }
    i { 
      font-size: 1.2rem;
    }
  }
  .account-links {
    display: flex;
    justify-content: center;
    margin-left: 2rem;
    a {
      font-size: 0.6rem; 
      color: v-bind(color);
      transition: .2s ease-in-out;
      margin: 0 0.3rem;
      &:hover {
        color: $footerHover;
        //text-shadow: 2px 2px 5px $footerHover;
        text-decoration: underline;
        transition: .2s ease-in-out;
      }
    }
    
    margin-bottom: 0.25rem;
    li {
      border-left: 2px solid $footerRest;
      line-height: 1;
      &:first-child {
        border-left: 0;
      }
    }
  }
  .copyright { 
    position: relative;
    font-size: 0.7rem;
  }
  .game-rating {
    position: absolute;
    top: 4.5rem;
    right: 10.5rem;
    img {
      max-height: 5rem;
    }
  }
}

.m-maplelane-footer__text {
  max-width: 48rem; margin: 0 auto 6rem;
  text-align: center;
  font-size: 0.9rem;
  color: white;
}

.mobile, .tablet {
  .m-footer {
    padding: 1rem 1rem 1.5rem;
    z-index: 999;
    .follow-us {
      .icon {
        width: 1.5rem;
        height: 1.5rem;

        &.icon-tiktok {
          margin-right: 0;
        }
      }
    }
    .social-links {
      .follow-us {
        display: none;
      }
      i {
        font-size: 2rem;
        &.svg {
          width: 1.75rem;
          height: 1.75rem;
        }
        svg {
          width: 1.75rem;
          height: 1.75rem;
        }
      }
    }
    .go-to-main-site, .copyright {
      font-size: 0.8rem;
    }
    .go-to-main-site {
      padding-left: 0;
      a {
        margin-left: 1.5rem;
      }
    }
    .copyright { line-height: 1.1rem; margin-bottom: 0.6rem;}
    .copy-links {
      width: 100%;
      flex-wrap: wrap;
      justify-content: center;
      padding: 0;
    }
    .account-links {
      margin-left: 0;
      a {
        font-size: 0.6rem;
      }
      .nav-item {
        //margin-bottom: 0.5rem;
        &.nav-item-terms {
          border: 0;
        }
      }
    }
  }
  .m-maplelane-footer__text {
    width: 88%; margin: 0 auto 6.5rem;
    text-align: center;
    font-size: 0.58rem;
    color: white;
  }
}
</style>